import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from '../../helpers/BaseError';

import API from '../../services/api';
import { toastService } from '../../services/toast.service';

import formulaKeys from '../formulas/_queryKeys';
import messageContentQueryKeys from '../message-content/_queryKey';
import useGetCurrentMessageContent from '../message-content/useGetCurrentMessageContent';
import formulaButtonsKeys from './_queryKeys';

export default function useFormulaButtonsDeleteMutation(formulaId: number) {
    const { currentMessageContentId } = useGetCurrentMessageContent();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse<string>, BaseError>({
        mutationFn: () =>
            API.deleteFormulaButtons(formulaId, {
                message_content_id: currentMessageContentId,
            }),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: formulaButtonsKeys.formulaButtons(
                    formulaId,
                    currentMessageContentId,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaById(formulaId),
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.approvedFormulaById(
                    formulaId,
                    currentMessageContentId,
                ),
            });
            if (currentMessageContentId) {
                queryClient.invalidateQueries({
                    queryKey: messageContentQueryKeys.messageContent(
                        currentMessageContentId,
                    ),
                });
            }
            toastService.showSuccess('Buttons deleted');
        },
    });
}
